import * as React from 'react';

type Variant = 'primary' | 'orange' | 'ghost';
type Size = 'sm' | 'md' | 'lg';

type Props = {
  variant?: Variant;
  size?: Size;
  full?: boolean;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  type?: 'button' | 'submit';
};

/**
 * V3Button — base button atom for the v3 design system.
 *
 * Variants:
 *  - primary  : navy background, white text  (default)
 *  - orange   : orange CTA
 *  - ghost    : transparent w/ border
 *
 * Sizes: sm | md (default) | lg
 * `full` makes it 100% width.
 */
const V3Button: React.SFC<Props> = ({
  variant = 'primary',
  size = 'md',
  full = false,
  disabled = false,
  onClick,
  icon,
  children,
  type = 'button',
}) => {
  const cls = [
    'v3-btn',
    `v3-btn-${variant}`,
    size !== 'md' ? `v3-btn-${size}` : '',
    full ? 'v3-btn-full' : '',
  ].filter(Boolean).join(' ');

  return (
    <button type={type} className={cls} disabled={disabled} onClick={onClick}>
      {icon}
      {children}
    </button>
  );
};

export default V3Button;
